import { IResponse } from "models";

export enum ActionType {
  GET_FACE_SCALE_CHART = "action/GET_FACE_SCALE_CHART",
  GET_FACE_SCALE_CHART_SUCCESS = "action/GET_FACE_SCALE_CHART_SUCCESS",
  GET_FACE_SCALE_CHART_ERROR = "action/GET_FACE_SCALE_CHART_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface FaceScalePayload {
  aggregate_date_to: string;
}

export interface FaceScaleResponse extends IResponse {
  amounts: any;
}
